import { Box } from "devextreme-react";
import { Item } from "devextreme-react/box";
import React from "react";
import "./avatar.css"

function Avatar() {
    return (

        <Box
            direction='row'
            width="100%">
            <Item ratio={0}
                baseSize="auto"
            >
                <img src='img/oktay.jpg' width={60} className='avatar'></img>
            </Item>
            <Item ratio={1}>
                <div className="info">
                    <div className="name">Oktay Kaynarca</div>
                    <div><span> E - 15 Şubat 1975</span></div>
                    <div className="department">Elektrik Bakım Onarım Birimi</div>
                </div>



            </Item>
        </Box>

    )
}

export default Avatar